import React from 'react';
import { Route, Routes } from 'react-router-dom';
import { ThemeProvider } from 'styled-components';
import { CookiesProvider } from 'react-cookie';

import BondingCurve from 'pages/BondingCurve';
import { darkNew } from 'theme/theme';
import { GlobalStyle } from 'theme/GlobalStyle';
import ChainProvider from 'context/chain/ChainContext';
import ExchangeProvider from 'context/exchange/ExchangeContext';
import ModalProvider from 'context/modal/ModalContext';
import MainHeader from 'components/MainHeader';
import SelectValidator from 'components/Modals/BridgeStaking/SelectValidator';
import ValidatorNode from 'components/Modals/BridgeStaking/ValidatorNode';
import BridgeSwapMain from 'components/Modals/BridgeModals/BridgeSwapMain';
import BridgeInitial from 'components/Modals/BridgeModals/BridgeInitial';
import BridgeWallets from 'components/Modals/OnomyWalletSelect';
import BridgeConnectOnomy from 'components/Modals/BridgeModals/BridgeConnectOnomy';
import BridgeWelcome from 'components/Modals/BridgeModals/BridgeWelcome';
import './assets/font-faces.css';
import { ErrorBoundary } from 'components/ErrorBoundary';
import { RequireEthNetwork } from 'components/RequireEthNetwork';
import { RequireTradingEnabled } from 'components/RequireTradingEnabled';
import TransactionFailedModal from 'components/Modals/components/TransactionFailedModal';

function App() {
  return (
    <CookiesProvider>
      <ThemeProvider theme={darkNew}>
        <GlobalStyle />
        <ErrorBoundary
          fallback={
            <TransactionFailedModal
              error="See console for details"
              header="Unexpected Error"
              disableClose
            />
          }
        >
          <ChainProvider>
            <RequireEthNetwork>
              <RequireTradingEnabled>
                <ExchangeProvider>
                  <ModalProvider>
                    <MainHeader />
                    <BondingCurve />
                    <Routes>
                      <Route path="/" element={<></>} />
                      <Route path="/validators/" element={<SelectValidator />} />
                      <Route path="/validators/:validatorId/*" element={<ValidatorNode />} />
                      <Route path="/bridge" element={<BridgeSwapMain />} />
                      <Route path="/bridge-initial" element={<BridgeInitial />} />
                      <Route path="/bridge-wallets" element={<BridgeWallets />} />
                      <Route path="/bridge-connect-onomy" element={<BridgeConnectOnomy />} />
                      <Route path="/bridge-welcome" element={<BridgeWelcome />} />
                    </Routes>
                  </ModalProvider>
                </ExchangeProvider>
              </RequireTradingEnabled>
            </RequireEthNetwork>
          </ChainProvider>
        </ErrorBoundary>
      </ThemeProvider>
    </CookiesProvider>
  );
}

export default App;
